import { Component, HostListener, OnInit } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { SessionService } from '@app/core/services/session.service';
import { Title } from '@angular/platform-browser';
import { ServerEventService } from './core/services/server-event.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public hideToolbar = true;
  public showFooter = false;
  public showBanner = false;

  constructor(private router: Router, private sessionService: SessionService, private titleService: Title, private serverEventService: ServerEventService<any>) { }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: any) {
      // Close the SSE listener before page unload
      this.serverEventService.disconnect();
  }

  public ngOnInit() {
      this.sessionService.sendSession = true;

      this.router.events.subscribe((data) => {
        if (data instanceof RoutesRecognized) {
          const routeData = data.state.root.firstChild.data;
          this.hideToolbar = !!routeData.hideToolbar;
          this.showFooter = !!routeData.showFooter;
          this.showBanner = !!routeData.showBanner;

          this.titleService.setTitle(routeData.pageTitle || 'Regpro.');
        }
      });
  }
}
